import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { switchMap } from "rxjs";
import { CommonService } from "src/app/services/common.service";
declare var $: any
@Component({
  selector: "app-main-sidebar",
  templateUrl: "./main-sidebar.component.html",
})
export class MainSidebarComponent implements OnInit {
  @Input() login: boolean = false;
  translation$ = this.translate.onLangChange.pipe(
    switchMap(({ lang }) => this.translate.getTranslation(lang))
  );
  currentLanguage: any = 'en';
  browserLang: any;
  languageCode: any = '';
  languages = [
    { 'languageCode': 'en', 'languageName': 'English' },
    { 'languageCode': 'fr', 'languageName': 'French' },
    { 'languageCode': 'it', 'languageName': 'Italian' },
    { 'languageCode': 'ja', 'languageName': 'Japanese' }
  ]
  constructor(public translate: TranslateService, private commonService: CommonService,) {
    translate.addLangs(['en', 'fr', 'it', 'ja']);
    translate.setDefaultLang('en');
    this.browserLang = translate.getBrowserLang();
    this.translate.setDefaultLang(this.browserLang);
    this.translate.use(this.browserLang);
  }
  selectedLanguage: string = ''
  ngOnInit(): void {
    this.languageCode = this.languages[0].languageCode;
    $('.carousel').carousel({
      interval: 300 * 10
    });
    this.currentLanguage = localStorage.getItem('selectedLang');
    if (this.currentLanguage) {
      this.currentLanguage = this.currentLanguage;
    }

  }

  languageChange(event: any) {
    this.currentLanguage = event;
    this.commonService.getSelectedLang.next(this.currentLanguage);
    this.translate.use(this.currentLanguage);
    localStorage.setItem('selectedLang', JSON.stringify(this.currentLanguage));
  }
}
